import React, { useState, useEffect } from "react";
import { Button, Grid, Container } from "@material-ui/core";
import HomePage from "../../Home";
import { VPaquetesStyle } from "./styles";
import FPaquetesGaleria from "../../Paquetes/FPaquetesGaleria";
import TPaquetes from "./../TPaqueteImagen";
import { useDispatch } from "react-redux";
import {
  getPaquetesImagenAll,
  clearPaquetesImagenState,
  getReporteExcelPaquetesImagen
} from "./../../../ducks/paqueteImagenDuck";
import BackDrop from "../../../global/BackDrop";
import FielBusqueda from "./../../../global/FielBusuqeda";
import BotonIcon from '../../../global/BotonIcon';
import ImageIcon from '@material-ui/icons/Image';
import BrokenImageIcon from '@material-ui/icons/BrokenImage';
import { useToggle } from "../../../hooks/useToggle";
import { ToastMessage } from "../../../global/ToastMessage";

export default function VPaquetes() {
  const classes = VPaquetesStyle();
  const dispatch = useDispatch();
  const [load, setLoad] = useState(false);
  const [buscar, setBuscar] = useState("0");
  const [rowTarget, setRowTarget] = useState({ IdPaquete: 0 });
  const [openModalGaleria, setOpenModalGaleria] = useState(false);
  const [botonImagen, onChangeBotonImagen] = useToggle();


  useEffect(() => {
    if (buscar === "0")
      setLoad(true);
    dispatch(getPaquetesImagenAll({ Busqueda: buscar, IsImagen: botonImagen })).then((Response) => {
      setLoad(false);
    });
    return () => {
      dispatch(clearPaquetesImagenState());
    };
  }, [dispatch, buscar, botonImagen]);

  const handleOpenGaleria = (rowTarget) => {
    setRowTarget(rowTarget);
    setOpenModalGaleria(!openModalGaleria);
  };

  const GeneraEXCEL = () => {
    setLoad(true)
    dispatch(getReporteExcelPaquetesImagen({ Busqueda: buscar, IsImagen: botonImagen })).then((Response) =>{
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: Response.Message,
          });
          break;
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: Response.Message,
          });
          break;
        default:
              const downloadUrl = window.URL.createObjectURL(new Blob([Response.data], {type: "application/vnd.ms-excel"}));
              const link = document.createElement('a');
              link.href = downloadUrl;
              let fchAct = new Date().toISOString();
              let fileName = 'Paquetes-' + fchAct + '.xlsx';
              link.setAttribute('download', fileName);
              document.body.appendChild(link);
              link.click();
              link.remove();
          ToastMessage.fire({
            icon: "success",
            title: "¡OPERACIÓN EXITOSA!",
          });
          break;
      }
      setLoad(false)
    });

  }

  return (
    <HomePage>
      <Container fixed>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.contentMargin}
        >
          <Grid item xs={3}>
            <FielBusqueda setBusqueda={setBuscar} />
          </Grid>
          <Grid item xs={4} className={classes.flexEnd} >
            <BotonIcon title={!botonImagen ? "Paquetes con imagen" : "Paquetes sin imagen"} onClick={onChangeBotonImagen} >
              {
                !botonImagen ?
                  <ImageIcon /> : <BrokenImageIcon />
              }
            </BotonIcon>
            <Button variant="outlined" color="primary" onClick={GeneraEXCEL}>Descargar reporte</Button>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <TPaquetes
              onGaleria={handleOpenGaleria}
            />
          </Grid>
        </Grid>
      </Container>
      <BackDrop open={load} />
      <FPaquetesGaleria
        open={openModalGaleria}
        setOpen={setOpenModalGaleria}
        rowData={rowTarget}
      />
    </HomePage>
  );
}
